'use strict';

var React = require('react/addons');

var _ = require('lodash');

var Header = require('./components/header.jsx');
var Footer = require('./components/footer.jsx');
var GithubRibbon = require('./components/github-ribbon.jsx');
var CodeSnippet = require('./components/code-snippet.jsx');
var Install = require('./components/install.jsx');
var Features = require('./components/features.jsx');
var CustomRender = require('./components/custom-render.jsx');

var Choice = require('../src');

var singleExample = "var Choice = require('react-choice');\n\nvar countries = [\n  {\"label\": \"Afghanistan\", \"value\": \"AF\"},\n  {\"label\": \"Albania\", \"value\": \"AL\"},\n  {\"label\": \"Algeria\", \"value\": \"DZ\"},\n  // etc...\n];\n\nvar options = countries.map(function(country) {\n  return (\n    <Choice.Option value={country.value}>\n      {country.label}\n    </Choice.Option>\n  );\n});\n\n// Render component\n<Choice.Select placeholder=\"Select a country\">\n  {options}\n</Choice.Select>\n";
var multipleExample = "var Choice = require('react-choice');\n\nvar countries = [\n  {\"label\": \"Afghanistan\", \"value\": \"AF\"},\n  {\"label\": \"Albania\", \"value\": \"AL\"},\n  {\"label\": \"Algeria\", \"value\": \"DZ\"},\n  // etc...\n];\n\nvar options = countries.map(function(country) {\n  return (\n    <Choice.Option value={country.value}>\n      {country.label}\n    </Choice.Option>\n  );\n});\n\n// Render component\n<Choice.SelectMultiple placeholder=\"Select a country\">\n  {options}\n</Choice.SelectMultiple>\n";

var COUNTRIES = require('./data/countries.js');

var Index = React.createClass({
  displayName: 'Index',

  getDefaultProps: function getDefaultProps() {
    return {};
  },

  render: function render() {
    var options = _.map(COUNTRIES, function (option) {
      return React.createElement(
        Choice.Option,
        { key: option.value, value: option.value },
        option.label
      );
    });

    return React.createElement(
      'main',
      { id: 'app' },
      React.createElement(Header, null),
      React.createElement(GithubRibbon, null),
      React.createElement(
        'div',
        { className: 'content' },
        React.createElement(
          'div',
          { className: 'examples' },
          React.createElement(
            'div',
            { className: 'example-single' },
            React.createElement(
              'div',
              { className: 'example' },
              React.createElement(
                'h2',
                null,
                'Single Choice'
              ),
              React.createElement(
                Choice.Select,
                { placeholder: 'Select a country' },
                options
              ),
              React.createElement(
                CodeSnippet,
                { language: 'javascript', toggle: false },
                singleExample
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'example-multiple' },
            React.createElement(
              'div',
              { className: 'example' },
              React.createElement(
                'h2',
                null,
                'Multiple Choice'
              ),
              React.createElement(
                Choice.SelectMultiple,
                { placeholder: 'Select a country' },
                options
              ),
              React.createElement(
                CodeSnippet,
                { language: 'javascript', toggle: false },
                multipleExample
              )
            )
          ),
          React.createElement('div', { style: { clear: 'both' } })
        ),
        React.createElement(Features, null),
        React.createElement(Install, null),
        React.createElement(
          'div',
          { className: 'tutorials' },
          React.createElement(
            'h2',
            null,
            'Tutorials'
          ),
          React.createElement(CustomRender, null)
        )
      ),
      React.createElement(Footer, null)
    );
  }
});

module.exports = Index;


/*****************
 ** WEBPACK FOOTER
 ** ./example/index.jsx
 ** module id = 101
 ** module chunks = 0
 **/